// eslint-disable-next-line
// @ts-nocheck
const sortBySortOrder = (dataMap, children) => {
	children.forEach((id) => {
		const { children } = dataMap.get(id);
		if (children?.length) {
			sortBySortOrder(dataMap, children);
		}
	});

	children.sort((firstKey, secondKey) => {
		const firstItem = dataMap.get(firstKey);
		const secondItem = dataMap.get(secondKey);

		return firstItem.sort_order - secondItem.sort_order;
	});
};

const createNavDataStore = (data) => {
	const roots = new Set();
	const dataMap = new Map();
	const tocItems = [];
	const levels = {};

	data.forEach((item, id) => {
		if (item['@odata.type'] !== '#CommandBarSectionItem') {
			dataMap.set(id, item);
			return;
		}

		const { related_id: relatedId } = item;
		const relatedItem = data.get(relatedId);
		const { 'parent_menu@aras.id': parentId } = relatedItem;

		if (parentId) {
			const level = (levels[parentId] ||= []);
			level.push(id);
		} else {
			roots.add(id);
		}

		const tocItem = {
			...item
		};
		if (relatedItem['@odata.type'] === '#CommandBarMenu') {
			tocItem.children = [];
		}

		tocItems.push(tocItem);
		dataMap.set(id, tocItem);
	});

	Object.entries(levels).forEach(([parentId, children]) => {
		tocItems
			.filter(({ related_id: relatedId }) => {
				return relatedId === parentId;
			})
			.forEach((item) => {
				item.children = children;
			});
	});

	return { roots, dataMap };
};

export default (nav, data) => {
	const dataStore = createNavDataStore(data);
	const { dataMap, roots } = dataStore;
	const rootsArr = [...roots];
	sortBySortOrder(dataMap, rootsArr);
	nav.dataStore.items = dataMap;
	nav.dataStore.roots = new Set(rootsArr);
	return nav.render();
};
